import templateUrl from 'emun.salesrep/salesrep-notes.htm'
class SalesRepNotesController {
    constructor($rootScope, createAutoQuery, $window) { 
        var scope = this;
        //this.users = createAutoQuery({
        //    url: 'QueryUsers.json?salesRepId=' + this.salesrep.id,
        //    autoLoad: true,
        //    onLoaded: function(args) {
        //        if (args.results.total > 0) {
        //            this.notes = createAutoQuery({
        //                url: 'QueryRetailerNotes.json?userName=' + args.results[0].fullName,
        //                orderBy: '-CreatedOn',
        //                autoLoad: true,
        //                pageSize: 10
        //            })
        //        }
        //    }
        //})
        this.notes = createAutoQuery({
            url: 'QueryRetailerNotes.json?dateRange=Last30Next30&repId=' + this.salesrep.id,
            orderBy: '-CreatedOn',
            autoLoad: true,
            pageSize: 10
        })
        $rootScope.$on('customerNoteSaved', function() {
            scope.notes.load(true);
        });
        $rootScope.$on('customerNoteDeleted', function() {
            scope.notes.load(true);
        });
    }
}

let SalesRepNotes = {
    bindings: {
        salesrep: '<'
    },
    //require: {
    //    container: '^salesrepDashboard'
    //},
    controller: SalesRepNotesController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}


export default SalesRepNotes